import { render, staticRenderFns } from "./DeleteRecordEdit.vue?vue&type=template&id=cc08457e&"
import script from "./DeleteRecordEdit.vue?vue&type=script&lang=js&"
export * from "./DeleteRecordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports